import React, { useEffect, useState } from "react";
import { ConfigurationTileProps } from "../../types";
import { Modal } from "@mantine/core";
import "./configurationTile.css";
import "../popup/confirmationPopUp.css";
import { getMetaDataConfig } from "../../services/uiConfigService";
import { getConfigFromClientConfig } from "../../services/bannerServices";
import { OptionType } from "../../features/manageHomepage/ManageHomePageTypes";
import { Autocomplete, Button, Checkbox, Chip, FormControlLabel, ListItemText, MenuItem, Radio, TextField } from "@mui/material";
import { setCurrentRole } from "../../stateManagement/actions/roleActions";
import { useSelector } from "react-redux";
import store from "../../stateManagement/store";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import { featuresWithShortcutKeys } from "../dms_common/DmsUtils";
import useShortcutKeys from "../dms_common/ShortcutKeys";

export function NavbarConfigurationTile(props: ConfigurationTileProps) {
    const [showModal, setShowModal] = useState(false);
    const [roleOptions, setRoleOptions] = useState<OptionType[]>([]);
    const savedRole:any = useSelector(() => store.getState().roleState.role)
    const [selectedRole, setSelectedRole] = useState<string>(() => {
        if (savedRole?.id) {
            try {
                return savedRole.id; 
            } catch (error) {
                console.error("Error parsing savedRole:", error);
                return "";
            }
        }
        return "";
    });
    

    const handleClick = async() => {
        // if (props.activeNavbar === "Salescode Studio") {
        //     let clientConfig = await getMetaDataConfig("clientconfig");
        //     const portal_configuration = getConfigFromClientConfig(clientConfig,"portal_configuration");
        //     const appTypeAndDesignationConfig = portal_configuration?.find((option: {name: string}) => {
        //       return option.name === "appTypeAndDesignationInfo"
        //     });
        //     const rolesPresent = portal_configuration?.find((option: {name: string}) => {
        //       return option.name === "rolesPresent"
        //     });
        //     // 1st chec in appTYpe 
        //     if (!appTypeAndDesignationConfig) {
        //         if (rolesPresent && Array.isArray(rolesPresent.value)) {
        //             if (rolesPresent.value.length > 1) {
        //                 if(!savedRole?.id){
        //                 // setShowModal(true);
        //                 }
        //                 setRoleOptions(rolesPresent.value);
        //             } else if (rolesPresent.value.length === 1) {
        //                 setCurrentRole(rolesPresent.value[0])
        //             } else {
        //                 setCurrentRole({ id: "retailer", label: "Retailer" })
        //             }
        //         } else {
        //             setCurrentRole({ id: "retailer", label: "Retailer" })
        //         }
        //         if (!savedRole?.id && rolesPresent?.value?.length > 1) {
        //             setShowModal(true);
        //         } else {
        //             props.onClick();
        //         }
        //     }
        //     else{
        //         props.onClick();
        //     }
        // }
        // else{
        //     props.onClick();
        // }
          
        //   if (rolesPresent && Array.isArray(rolesPresent.value)) {
        //     if (rolesPresent.value.length > 1) {
        //       setRoleOptions(rolesPresent.value); 
        //     } else if (rolesPresent.value.length === 1) {
        //         setCurrentRole(rolesPresent.value[0])
        //     } else{
        //         setCurrentRole({ id: "retailer", label: "Retailer" })
        //     }
        //   }else{
        //     setCurrentRole({ id: "retailer", label: "Retailer" })
        //   }
        //     if (!savedRole?.id && rolesPresent?.value?.length>1) {
        //         setShowModal(true); 
        //     } else {
        //         props.onClick(); 
        //     }
        // } else {
        //     props.onClick();
        // }
        props.onClick();
    };
    const [selectedAppRole, setSelectedAppRole] = useState<string | null>(null);
    const [selectedPortalRole, setSelectedPortalRole] = useState<string | null>(null);
    const [openDropdown, setOpenDropdown] = useState<boolean>(false);
    const handleRoleChange =(option: any) => {
        if (!option) return;

    if (option.category === "App-based Role") {
      setSelectedAppRole(option.id);
      // only change role if it is not the same as the saved role
      if(option?.id !== savedRole?.id){
        setCurrentRole(option || undefined)
      }
    } else if (option.category === "Portal-based Role") {
      setSelectedPortalRole(option.id);
      // only change role if it is not the same as the saved role
      if(option?.id !== savedRole?.id){
        setCurrentRole(option || undefined)
      }
    }
    if (
        (option.category === "App-based Role" && selectedPortalRole) ||
        (option.category === "Portal-based Role" && selectedAppRole)
      ) {
        setOpenDropdown(false);
      }
    };
    const roles = [
        ...roleOptions.map((role) => ({ ...role, category: "App-based Role" })),
        { id: "reportAdmin", label: "Report Admin", category: "Portal-based Role" },
        { id: "distributor", label: "Distributor", category: "Portal-based Role" },
        { id: "businessAdmin", label: "Business Admin", category: "Portal-based Role" },
      ]; 
      const selectedRoles = roles.filter(
        (role) =>
          role.id === selectedAppRole || role.id === selectedPortalRole
      );
    const shortcutKey: string = featuresWithShortcutKeys[props.label?.toLocaleUpperCase()] || ""; 
    const { ctrlKey } = useShortcutKeys();
    return (
        <>
            <div
                className={`navbar-config-card ${props.active ? "active" : ""}`}
                onClick={handleClick}
            >
                <div className={`navbar-config-label ${props.active ? "active" : ""}`}>
                    <span>{props.label}</span>&nbsp;
                   {shortcutKey && <span style={{ fontSize: "11px", fontWeight: 600, color: '#ADADAD' }}>{`(${ctrlKey} + ${shortcutKey})`}</span> }
                </div>
                
            </div>

            <Modal
                centered
                withCloseButton={false}
                overlayOpacity={0.55}
                overlayBlur={3}
                opened={showModal}
                onClose={() => setShowModal(false)}
                radius="lg"
                size="420px"
                className="confirmationPopUp-modalContainer"
            >
                <div className="modal-content" style={{display: "flex",flexDirection: "column",alignItems: "center"
}}>
                    <div style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        margin: "10px",
                        width: "38px", 
                        height: "38px", 
                        borderRadius: "50%",
                        backgroundColor: "#1c7ea0",
                        padding: "5px" 
                    }}>
                        <svg stroke="white" fill="none" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round" width="20" height="20" xmlns="http://www.w3.org/2000/svg">
                            <polyline points="9 11 12 14 22 4"></polyline>
                            <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"></path>
                        </svg>
                    </div>
                    <p style={{textAlign:"center",color:"#909090",fontSize:"16px",marginBottom:"1em"}}>Select a role to manage configuration</p>
                    <Autocomplete
                        style={{margin:"auto",width:"70%"}}
                        options={roleOptions}
                        disableClearable
                        getOptionLabel={(option) => option.label}
                        value={roleOptions.find((role) => role.id === selectedRole) || undefined}
                        onChange={(event, newValue) => {
                            setSelectedRole(newValue ? newValue.id : "");
                            // only change role if it is not the same as the saved role
                            if(newValue?.id !== savedRole?.id){
                                setCurrentRole(newValue || undefined)
                            }
                            // localStorage.setItem("role",JSON.stringify(newValue))
                        }}
                        renderInput={(params) => (
                            <TextField {...params} label="Select role" variant="outlined" />
                        )}
                    />
                    {/* <Autocomplete
                        open={openDropdown}
                        onClose={() => setOpenDropdown(false)}
                        onOpen={() => setOpenDropdown(true)}
                        style={{ margin: "auto", width: "80%" }}
                        options={roles}
                        disableClearable
                        multiple
                        disableCloseOnSelect
                        value={selectedRoles}
                        groupBy={(option) => option.category}
                        getOptionLabel={(option) => option.label}
                        onChange={handleRoleChange}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Select roles"
                                variant="outlined"
                                // value={getDropdownValue()}
                            />
                        )}
                        renderOption={(props, option) => (
                            <li {...props} key={option.id} onClick={() => { handleRoleChange(option) }}
                            >
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={
                                                (option.category === "App-based Role" && selectedAppRole === option.id) ||
                                                (option.category === "Portal-based Role" && selectedPortalRole === option.id)
                                            }
                                        />
                                    }
                                    label={option.label}
                                />
                            </li>
                        )}
                        renderTags={(tagValue, getTagProps) => (
                            <>
                              {tagValue.map((option, index) => (
                                <Chip
                                  deleteIcon={undefined}
                                  label={option.label}
                                  {...getTagProps({ index })}
                                />
                              ))}
                            </>
                          )}       
                    /> */}
                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", marginTop: "1rem" }}>
                        <Button
                            onClick={() => {
                                if (selectedRole) {
                                    setShowModal(false);
                                    props.onClick();
                                }
                            }}
                            disabled={!selectedRole}
                            variant="contained"
                            color="primary"
                            style={{ width: "fit-content", backgroundColor: selectedRole && "#24c6b1"}}
                        >
                            Continue
                        </Button>
                    </div>

                </div>
            </Modal>
        </>
    );
}
